let downloadFun = () => {
  let u = navigator.userAgent
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  function judgeBrand (sUserAgent) {
    var isIphone = sUserAgent.match(/iphone/i) == "iphone";
    var isHuawei = sUserAgent.match(/huawei/i) == "huawei";
    var isHonor = sUserAgent.match(/honor/i) == "honor";
    var isOppo = sUserAgent.match(/oppo/i) == "oppo";
    var isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
    var isVivo = sUserAgent.match(/vivo/i) == "vivo";
    var isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
    var isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
    var isRedmi = sUserAgent.match(/redmi/i) == "redmi";
    var isSamsung = sUserAgent.match(/sm-/i) == "sm-";

    if (isIphone) {
      // return 'iphone';
    } else if (isHuawei || isHonor) {
      // alert('oppomarket://details?packagename=com.jlkf.zhongying')
      location.href = 'appmarket://details?id=com.jlkf.zhongying'
      // alert(123)
    } else if (isOppo || isOppoR15) {
      // alert(123)

      location.href = "oppomarket://details?packagename=com.jlkf.zhongying"
      // return 'oppo';
    } else if (isVivo) {
      // return 'vivo';
      location.href = "vivomarket://details?id=com.jlkf.zhongying"
    } else if (isXiaomi || isRedmi || isXiaomi2s) {
      // return 'xiaomi';
      location.href = "mimarket://details?id=com.jlkf.zhongying"
    } else if (isSamsung) {
      // location.href = "market://details?id=com.jlkf.zhongying"
      location.href = "https://data.nanaco.com.cn/nanaco-data/apk/nanacoLatest.apk"
      location.href = "https://play.google.com/store/apps/details?id=com.jlkf.zhongying"
      // return 'samsung';
    } else {
      // return 'default';
      location.href = "https://data.nanaco.com.cn/nanaco-data/apk/nanacoLatest.apk"
      // location.href = "market://details?id=com.jlkf.zhongying"
    }
  }
  if (isAndroid) {
    // 这个是安卓操作系统
    judgeBrand(navigator.userAgent.toLowerCase())
  }
  if (isIOS) {
    // 这个是ios操作系统
    // alert(dataJson)
    location.href = 'itms-apps://itunes.apple.com/app/nanaco-中国生活支援アプリ/id1329328896'
  }
}
export default downloadFun


// WEBPACK FOOTER //
// ./src/components/pe-home/js/download.js